<template>
  <base-divider v-if="usd && step !== PURCHASE_STEPS.RECEIPT" class="tw-my-6" />
  <p
    v-if="step !== PURCHASE_STEPS.RECEIPT || !usd"
    class="tw-text-xs tw-font-medium tw-uppercase tw-tracking-widest tw-mb-3"
  >
    {{
      step === PURCHASE_STEPS.RECEIPT
        ? $t('marketplace.remaining_balance')
        : $t('marketplace.payment_method')
    }}
  </p>
  <template v-if="!usd">
    <div
      :class="[
        {
          'tw-border-2 mod-global--border-radius tw-p-5':
            step === PURCHASE_STEPS.CART,
        },
        !notEnoughBoth ? 'tw-border-primary' : 'tw-border-dark-1',
      ]"
    >
      <div
        class="tw-flex tw-justify-between"
        :class="{ 'tw-mb-3': showButton }"
      >
        <div class="tw-flex tw-items-center tw-gap-x-2 tw-opacity-70">
          <p>{{ $t('marketplace.wallet_balance') }}</p>
        </div>
        <loading-title v-if="loadingBalance" />
        <p v-else>
          {{ (balance - deficit).toLocaleString() }}
          {{ tokenName }}
        </p>
      </div>
      <base-link
        v-if="showButton"
        :to="{ name: MOD_BROWSE_ROUTE_TOKEN_PACKS }"
        :link-primary="false"
        class="mod-input-btn--base game-secondary-button-color game-secondary-text hover:game-secondary-button-color-hover focus:game-secondary-button-color-hover hover:game-secondary-text-hover focus:game-secondary-text-hover tw-w-full tw-h-10"
        @click="() => (purchaseMod = mod)"
        >{{ $t('marketplace.top_up') }}</base-link
      >
    </div>
  </template>
  <template v-else-if="step === PURCHASE_STEPS.CHECKOUT">
    <div class="tw-space-y-4">
      <div
        v-for="method in paymentMethods"
        :key="method.payment_method_id"
        class="tw-flex tw-items-end"
      >
        <base-icon
          v-if="method.provider"
          :icon="method.provider"
          class="tw-h-5 tw-fill-current"
        />
        <p v-if="method.display" class="tw-text-right tw-ml-auto">
          {{ method.display }}
        </p>
        <p v-if="paymentMethods.length > 1" class="tw-text-right tw-w-14">
          {{ humanPriceFormat(convertToDecimal(getAmount(method.amount))) }}
        </p>
      </div>
    </div>
  </template>

  <p
    v-if="!loadingBalance && !usd && notEnoughBoth"
    class="tw-text-danger tw-mt-4"
  >
    {{ $t('marketplace.not_enough_vc') }}
  </p>

  <template v-else-if="step === PURCHASE_STEPS.CHECKOUT && !usd">
    <base-divider class="tw-my-6" />

    <p
      class="tw-text-xs tw-font-medium tw-uppercase tw-tracking-widest tw-mb-3"
    >
      {{ $t('marketplace.balance_after') }}
    </p>
    <div class="tw-flex tw-w-full tw-justify-between">
      <span class="tw-opacity-70">{{ $t('marketplace.wallet_balance') }}</span>
      <span class="tw-font-bold">
        {{ (purchaseBalance - deficit).toLocaleString() }}
        {{ tokenName }}
      </span>
    </div>
  </template>
</template>

<script>
import { MOD_BROWSE_ROUTE_TOKEN_PACKS } from '@config/routeNames.js'
import { useResourceValue, useMonetization } from '@composables'
import LoadingTitle from '@components/Loading/LoadingTitle.vue'
import { PURCHASE_STEPS } from '@config/options.js'
import { computed, toRefs } from 'vue'

export default {
  components: {
    LoadingTitle,
  },
  props: {
    tokenName: {
      type: String,
      required: true,
    },
    usd: {
      type: Boolean,
      default: false,
    },
    balance: {
      type: Number,
      default: null,
    },
    deficit: {
      type: Number,
      default: null,
    },
    price: {
      type: Number,
      default: 0,
    },
    loadingBalance: {
      type: Boolean,
      default: false,
    },
    showButton: {
      type: Boolean,
      default: false,
    },
    game: {
      type: Object,
      default: () => ({}),
    },
    mod: {
      type: Object,
      default: () => ({}),
    },
    step: {
      String,
      default: PURCHASE_STEPS.CART,
      validator: (val) =>
        [
          PURCHASE_STEPS.CART,
          PURCHASE_STEPS.CHECKOUT,
          PURCHASE_STEPS.RECEIPT,
        ].includes(val),
    },
    paymentMethods: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:earned'],
  setup(props) {
    const { balance, deficit, price } = toRefs(props)

    const { purchaseMod } = useMonetization()

    const notEnoughBoth = computed(
      () => balance.value - deficit.value < price.value
    )

    const purchaseBalance = computed(() => balance.value - price.value)

    return {
      MOD_BROWSE_ROUTE_TOKEN_PACKS,
      useResourceValue,
      purchaseBalance,
      PURCHASE_STEPS,
      notEnoughBoth,
      purchaseMod,
    }
  },
}
</script>
